/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
export default class AnnotationLayerDecorator extends Component {
  constructor(...args) {
    super(...args);

    this.loadAnnotationLayerFactory = () => {
      return import(
      /* webpackChunkName: "pdf-js" */
      '../../lib/pdf-js').then(({
        AnnotationLayerBuilder
      }) => this.annotationLayerFactory = new AnnotationLayerBuilder.DefaultAnnotationLayerFactory());
    };

    this.renderAnnotationLayer = () => {
      const {
        pageObject,
        viewport
      } = this.props;

      if (this.annotationLayerBuilder) {
        // Re-rendering the annotations adds another `.annotationLayer` div with
        // another set of links. Hide the previous one to avoid duplication.
        this.annotationLayerBuilder.hide();
      }

      this.annotationLayerBuilder = this.annotationLayerFactory.createAnnotationLayerBuilder(this.annotationLayer, pageObject);
      const annotationViewport = viewport.retinaScale === 1 ? viewport : pageObject.getViewport({
        scale: viewport.scale / viewport.retinaScale
      });
      this.annotationLayer.style.height = `${annotationViewport.height}px`;
      this.annotationLayer.style.width = `${annotationViewport.width}px`;
      this.annotationLayerBuilder.render(annotationViewport, 'display');
    };
  }

  componentDidMount() {
    this.loadAnnotationLayerFactory().then(this.renderAnnotationLayer);
  }

  componentDidUpdate() {
    this.renderAnnotationLayer();
  }

  render() {
    return /*#__PURE__*/_jsx("div", {
      className: "display-flex align-center justify-center",
      style: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      },
      children: /*#__PURE__*/_jsx("div", {
        className: "annotation-layer",
        ref: c => this.annotationLayer = c
      })
    });
  }

}
AnnotationLayerDecorator.propTypes = {
  pageObject: PropTypes.object.isRequired,
  viewport: PropTypes.object.isRequired
};